var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPiechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3438 8C15.9375 5.78125 14.1562 4 11.9375 3.59375V8H16.3438ZM11.9375 9.5H10.4375V8V2.53125C10.4375 2.25 10.6562 2 10.9375 2C14.7812 2 17.9375 5.15625 17.9375 9C17.9375 9.28125 17.6875 9.5 17.4062 9.5H11.9375ZM7.875 12.0625C7.59375 11.7812 7.4375 11.4062 7.4375 11V4.84375C5.09375 5.6875 3.4375 7.90625 3.4375 10.5C3.4375 13.8125 6.125 16.5 9.4375 16.5C10.2812 16.5 11.0938 16.3438 11.8125 16.0312L7.875 12.0625ZM8.40625 3.09375C8.6875 3.03125 8.9375 3.28125 8.9375 3.5625V11L13.8125 15.9062C14.0312 16.125 14 16.4688 13.7812 16.625C12.5312 17.5 11.0312 18 9.4375 18C5.28125 18 1.9375 14.6562 1.9375 10.5C1.9375 6.71875 4.75 3.59375 8.40625 3.09375ZM18.375 11V11.0312C18.6562 11.0312 18.9062 11.25 18.8438 11.5625C18.625 13.2812 17.7812 14.8438 16.5312 16C16.3438 16.1562 16.0625 16.1562 15.875 15.9688L10.9375 11H18.375Z",
    fill: "#15161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPiechart);
export default __webpack_public_path__ + "static/media/icon-piechart.21ab45b3faf9f5ed876e257f1036e6d1.svg";
export { ForwardRef as ReactComponent };